exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UploadImageModal-module__wrapper___2xq9B{display:grid;gap:1.5rem}.UploadImageModal-module__wrapper___2xq9B h2{line-height:1}.UploadImageModal-module__wrapper___2xq9B .UploadImageModal-module__button-wrapper___aEBYp{display:grid;justify-content:end;gap:.75rem;grid-auto-flow:column}", ""]);

// exports
exports.locals = {
	"wrapper": "UploadImageModal-module__wrapper___2xq9B",
	"button-wrapper": "UploadImageModal-module__button-wrapper___aEBYp"
};